import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { getBaseStatus } from '@/utils/projectStatuses';
import type { Project } from '@/api/client';
import { highlightPlainText } from '@/utils/highlightSearchTerms';

interface TimeCellProps {
  project: Project;
  searchHighlightWords?: string[];
}

export const TimeCell = memo(function TimeCell({ project, searchHighlightWords }: TimeCellProps) {
  const value = project.time;
  const baseStatus = getBaseStatus(project.state);
  const isReady = baseStatus === 'Готов';
  const showPreliminary = !isReady && value;

  const timeContent =
    searchHighlightWords?.length && value
      ? highlightPlainText(value, searchHighlightWords)
      : value;

  const display = value ? (
    <div className="projects-table__time-cell">
      {showPreliminary && (
        <span className="projects-table__time-label">предварительное</span>
      )}
      <span className="projects-table__time-value">
        <strong>{timeContent}</strong>
      </span>
    </div>
  ) : null;

  return (
    <EditableCell project={project} fieldKey="time">
      {display ?? <span className="projects-table__empty-value">N/A</span>}
    </EditableCell>
  );
});
